import MSPIcon from 'images/organization/homepage/sections/industries/industriesIcon/msps-icon.svg'
import StartupIcon from 'images/organization/homepage/sections/industries/industriesIcon/startups-icon.svg'
import SchoolsIcon from 'images/organization/homepage/sections/industries/industriesIcon/schools-icon.svg'
import NonProfitIcon from 'images/organization/homepage/sections/industries/industriesIcon/non-profits-icon.svg'
import PublicWifiIcon from 'images/organization/homepage/sections/industries/industriesIcon/publicwifi-icon.svg'
import SMBIcon from 'images/organization/homepage/sections/industries/industriesIcon/smb-circle.svg'
import ChurchesIcon from 'images/organization/homepage/sections/industries/industriesIcon/churches-icon.svg'
import EnterpriseIcon from 'images/organization/homepage/sections/industries/industriesIcon/enterprise-icon.svg'

export const tabs = [
  {
    title: 'Enterprise',
    tabDescription: 'Global DNS security for enterprise networks.',
    contentTitle: 'For Enterprise',
    description: `Protect every office, data center, and remote user with centralized DNS security. Built to scale without appliances.`,
    options: ['SSO provisioning and API automation', 'Full query logs with SIEM export for audits'],
    href: '/industries/enterprise',
    icon: EnterpriseIcon,
  },
  {
    title: 'SMBs',
    tabDescription: 'Enhanced visibility and security for any workspace',
    contentTitle: 'For SMBs',
    description: `It doesn’t matter if you’re in-office or remote. Gain visibility on traffic patterns of your staff,
     block time-wasting services, and reduce the chance of a compromise by blocking malicious domains.`,
    options: [
      'Deploy on routers, company hardware or BYOD devices',
      'Integrate into existing workflows with a robust API to manage DNS settings',
    ],
    href: '/industries/smbs',
    icon: SMBIcon,
  },
  {
    title: 'MSPs',
    tabDescription: 'Empower your clients with hassle-free DNS layer protection',
    contentTitle: 'For MSPs',
    description: `Offer your clients a value-added service that protects their devices at the DNS layer,
     without the burden of ongoing management.`,
    options: [
      'Enforce global policies and avoid duplication',
      'Delegate access to teams for seamless self-management while maintaining full control and top-down visibility',
    ],
    href: '/industries/msps',
    icon: MSPIcon,
  },
  {
    title: 'Startups',
    tabDescription: 'Protect and thrive with early startup security',
    contentTitle: 'For Startups',
    description: `It’s never too early to act on security for your startup. Protect your growing business from threats,
     without dedicated staff or burn rate increases.`,
    options: ['Quick self-onboarding for staff', 'Simple, modern UI built in 2023'],
    href: '/industries/startups',
    icon: StartupIcon,
  },
  {
    title: 'Schools',
    tabDescription: 'Safeguarding online security for students and staff',
    contentTitle: 'For Schools',
    description: `Safeguard students and staff from harmful online content,
     malware and phishing with easy-to-configure filtering options. Deploy on your router, or directly on end-user machines.`,
    options: ['No hardware and no VPN software', 'Affordable per-head pricing model'],
    href: '/industries/schools',
    icon: SchoolsIcon,
  },
  {
    title: 'Non-Profits',
    tabDescription: 'Prioritizing security for the common good',
    contentTitle: 'For Non-Profits',
    description: `You’re working for the common good and you shouldn’t compromise on security.
     Secure all devices and improve staff privacy in minutes.`,
    options: [
      'Easy to set up - intuitive self-onboarding or via MDM',
      'Affordable per-head pricing model',
    ],
    href: '/industries/non-profits',
    icon: NonProfitIcon,
  },
  {
    title: 'Public Wi-Fi Operators',
    tabDescription: 'Enhancing Wi-Fi hotspot security for guests',
    contentTitle: 'For Public Wi-Fi Operators',
    description: `If you operate a Wi-Fi hotspot that is accessed by guests or visitors,
     restricting what they can do on your network is the best way to stay secure and prevent your ISP from
      disconnecting your service for DMCA and other violations.
       Gain complete visibility on usage patterns, and enforce dynamic policies that change based on what time it is.`,
    options: [
      'Reduce liability by blocking harmful content',
      'Give your customers an Internet connection they won’t want to leave',
    ],
    href: '/industries/public-wifi-operators',
    icon: PublicWifiIcon,
  },
  {
    title: 'Faith-Based Organizations',
    tabDescription: 'Offer family-friendly Wi-Fi',
    contentTitle: 'For Faith-Based Organizations',
    description: `Block unwanted content, stay protected from malware attacks, and maintain a family-friendly guest Wi-Fi experience at your church or religious organization.`,
    options: [
      'Prevent access to unauthorized websites & apps',
      'Protect your staff and guests from cyber threats',
    ],
    href: '/industries/faith-based-organizations',
    icon: ChurchesIcon,
  },
]
